import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Title from '../../../components/typography/title.component'

class EmployeePageComponent extends React.Component {
	render() {
		return <Title>Funcionário</Title>
	}
}

const connectedEmployeePageComponent = withRouter(
	connect(null)(EmployeePageComponent)
)

export { connectedEmployeePageComponent as ModuleRootComponent }
